import styled from 'styled-components';
import { Headline500Skin } from '../../../atoms/Headline/HeadlineSkins';

const Wrapper = styled.div`
  margin-bottom: 25px;

  @media (${(props) => props.theme.benefits.mobileSwitch}) {
    margin-bottom: 0;
    padding-bottom: 100px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  margin-bottom: 35px;
  justify-content: flex-start;

  @media (${(props) => props.theme.benefits.mobileSwitch}) {
    justify-content: center;
  }

  img {
    max-height: 150px;
    max-width: 150px;
    width: 100%;
    height: 100%;
  }
`;

const Headline = styled.h3`
  color: ${(props) => props.theme.color.primary800};
  ${Headline500Skin};
  text-align: left;

  @media (${(props) => props.theme.benefits.mobileSwitch}) {
    text-align: center;
  }
`;

const Text = styled.div`
  margin-top: 10px;
  text-align: left;

  @media (${(props) => props.theme.benefits.mobileSwitch}) {
    text-align: center;
  }
`;

/**
 * @param {BenefitProps} props
 */

const BenefitsTile = ({ title, description, icon }) => {
  return (
    <Wrapper>
      {icon && icon !== '' && (
        <IconWrapper>
          <img src={icon} alt={title} />
        </IconWrapper>
      )}
      {title && title !== '' && <Headline>{title}</Headline>}
      {description && description !== '' && <Text>{description}</Text>}
    </Wrapper>
  );
};

export default BenefitsTile;
